import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const FareSkeletonInput = ({
  height,
  width = '100%',
  testId = 'fare-skeleton-input',
}: {
  height: number;
  width?: string | number;
  testId?: string;
}) => (
  <div className="flex-1" data-testid={testId}>
    <Skeleton height={height} width={width} borderRadius={8} />
  </div>
);

const FareEstimateFormSkeletonLoaderCmp = () => {
  return (
    <SkeletonTheme
      borderRadius="5rem"
      baseColor="#E1E8EF"
      highlightColor="#FEFEFE"
      duration={2.0}
    >
      <div
        className="w-full flex flex-col items-center justify-center relative md:absolute bottom-[5.6rem] md:top-[45rem] md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 z-10"
        id="loading"
      >
        {/* Desktop Location Selector */}
        <div className="hidden md:flex w-full flex-col items-center justify-center top-[12rem] z-10">
          <div className="w-11/12 max-w-[108rem]">
            <div className="p-6 rounded-t-2xl bg-white max-w-[17rem] shadow-sm">
              <div className="flex items-center">
                <FareSkeletonInput height={40} />
              </div>
            </div>
          </div>
        </div>

        {/* Main Card */}
        <div className="w-11/12 max-w-[108rem] pt-6 pb-10 px-6 rounded-r-2xl rounded-bl-2xl rounded-tl-2xl md:rounded-tl-none shadow-sm bg-white">
          {/* Desktop Inputs Row */}
          <div className="hidden md:flex items-center justify-between space-x-4">
            {['input1', 'input2', 'input3', 'input4', 'input5'].map(key => (
              <FareSkeletonInput key={key} height={80} />
            ))}
            <FareSkeletonInput height={80} width={150} />
          </div>

          {/* Mobile Inputs */}
          <div className="md:hidden">
            <div className="mb-4 flex items-center">
              <FareSkeletonInput height={47} />
            </div>
            <div className="mb-8 flex items-center">
              <FareSkeletonInput height={47} />
            </div>
            <FareSkeletonInput height={45} testId="fare-skeleton-button" />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default FareEstimateFormSkeletonLoaderCmp;
